/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Paypoints/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import CustomOptions from './CustomOptions/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Paypoints({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/PaymentProviders/AddAction/Content/Content/Payabli/Paypoints",
  onChange
  
}) {
let addProviderPayabliSelectedPaypointValueData = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'payabli.selected_paypoint',
})
let addProviderPayabliSelectedPaypointChangeData = fromData.useDataChange({ viewPath,
context: 'add_provider',
path: 'payabli.selected_paypoint',
})
let addProviderPayabliPaypointsValueData = fromData.useDataFormat({ viewPath,
context: 'add_provider',
path: 'payabli.paypoints',
format: fromFormat.isEmptyList,
})
let addProviderPayabliSelectedPaypointValueData1 = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'payabli.selected_paypoint',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="add_provider.payabli.selected_paypoint"
 value={addProviderPayabliSelectedPaypointValueData}
 onChange={addProviderPayabliSelectedPaypointChangeData}
 data="add_provider.payabli.paypoints"
 format="/Data/format.js isEmptyList"
 disabled={addProviderPayabliPaypointsValueData}
 required={true}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="PayPoint entryPoint ID"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
 data="add_provider.payabli.selected_paypoint"
 valueFilter={addProviderPayabliSelectedPaypointValueData1}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<CustomOptions
{...childProps}
  viewPath={`${viewPath}/CustomOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}